import axios from 'axios';

// Configuración automática basada en el entorno
const getBaseURL = () => {
  // Si estás en desarrollo (localhost)
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost/back/api';
  }
  
  // Si estás en producción, usa la variable de entorno o una URL por defecto
  return process.env.REACT_APP_API_URL || 'https://sigex.pe/subscription/back/api';
};

// Configuración base de axios
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interfaces para los tipos de datos
export interface RegisterData {
  email: string;
  telefono: string;
  ruc: string;
  razonSocial: string;
  rubro: string;
  numeroTrabajadores: number;
  tipoUsuario: string;
  password: string;
  confirmPassword: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface ForgotPasswordData {
  email: string;
}

export interface ResetPasswordData {
  password: string;
  confirmPassword: string;
  token: string;
}

export interface ApiResponse {
  success: boolean;
  message: string;
  data?: any;
}

// Funciones de API
export interface ValidateTokenResponse {
  success: boolean;
  valid: boolean;
  message: string;
  email?: string;
  name?: string;
}

export interface ResetPasswordRequest {
  token: string;
  nueva_contrasena: string;
}

// Actualizar authAPI con estas nuevas funciones
export const authAPI = {
  register: async (data: RegisterData): Promise<ApiResponse> => {
    try {
      // Mapear los campos al formato que espera el backend PHP
      const mappedData = {
        correo_electronico: data.email,
        telefono: data.telefono,
        ruc_peru: data.ruc,
        razon_social: data.razonSocial,
        numero_trabajadores: data.numeroTrabajadores,
        rubro: data.rubro,
        tipo_usuario: data.tipoUsuario,
        contrasena: data.password,
      };

      const response = await api.post('/create_account.php', mappedData);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Error en el registro');
    }
  },

  forgotPassword: async (data: ForgotPasswordData): Promise<ApiResponse> => {
    try {
      // Mapear el campo email a correo_electronico como espera el backend
      const mappedData = {
        correo_electronico: data.email,
      };
      
      const response = await api.post('/forgot_password.php', mappedData);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Error al enviar correo de recuperación');
    }
  },

  resetPassword: async (data: ResetPasswordData): Promise<ApiResponse> => {
    try {
      const response = await api.post(`/reset_password.php?token=${data.token}`, {
        password: data.password,
        confirmPassword: data.confirmPassword,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Error al restablecer contraseña');
    }
  },

  validateResetToken: async (token: string): Promise<ValidateTokenResponse> => {
    try {
      const response = await api.get(`/validate_reset_token.php?token=${token}`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Error al validar el token');
    }
  },

  resetPasswordWithToken: async (data: ResetPasswordRequest): Promise<ApiResponse> => {
    try {
      const response = await api.post('/reset_password.php', data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Error al cambiar la contraseña');
    }
  },
};

export default api;